import { render, staticRenderFns } from "./vRecipeNutritionLabelPrintout.vue?vue&type=template&id=9e9df912&scoped=true"
import script from "./vRecipeNutritionLabelPrintout.vue?vue&type=script&setup=true&lang=ts"
export * from "./vRecipeNutritionLabelPrintout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vRecipeNutritionLabelPrintout.vue?vue&type=style&index=0&id=9e9df912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9df912",
  null
  
)

export default component.exports